/* global google */
// google map
import { logo } from '../../img/index';

const initMap = () => {
  const mapView = document.querySelector('#map');
  const mapLocation = {
    lat: -5.354334, 
    lng: 105.219202
  };
  const options = {
    zoom: 15,
    center: mapLocation
  };

  const map = new google.maps.Map(mapView, options);

  const infoWindow = new google.maps.InfoWindow({
    content: '<h4 style="color: red;">PT Lambang Jaya</h4>'
  });

  const marker = new google.maps.Marker({
    position: mapLocation,
    map: map,
    icon: logo.mobile
  });

  marker.addListener('click', () => infoWindow.open(map, marker));
};

window.initMap = initMap;